const endpointCardReader = "https://localhost:5000";
export const pullDataFromIDCard = async () => {
    let health = await checkIsCardReaderAvailable()
    if (!health) {
        return;
    }
    let response = await getDataFromCardReader()
    if (!response) {
        return;
    }
    let data = response.data.data;

    return data
}

const getDataFromCardReader = async () => {
    let res = await axios.get(`${endpointCardReader}/api/card-info`).catch(error => {
        mySwal.fire({
            title: error.message,
            html: "<span>สามารถดาวน์โหลดโปรแกรมได้</span><a href='https://quinnus.sgp1.cdn.digitaloceanspaces.com/SmartIDCardReader/SmartIDCardReader.exe'>ที่นี่</a> <br/><a href='https://quinnus.sgp1.cdn.digitaloceanspaces.com/SmartIDCardReader/smartidcardreader-main.zip'>Source code</a>",
            icon: 'error'
        })
    })

    if (!res.data.success) return false

    return res
}

const checkIsCardReaderAvailable = async () => {
    let res = await axios.get(`${endpointCardReader}/health`).catch(error => {
        mySwal.fire({
            title: error.message,
            html: "<span>สามารถดาวน์โหลดโปรแกรมได้</span><a href='https://quinnus.sgp1.cdn.digitaloceanspaces.com/SmartIDCardReader/SmartIDCardReader.exe'>ที่นี่</a> <br/><a href='https://quinnus.sgp1.cdn.digitaloceanspaces.com/SmartIDCardReader/smartidcardreader-main.zip'>Source code</a>",
            icon: 'error'
        })
    })

    if (res.data.status != "ok") return false

    return true
}
